import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inlineCta"]

  connect() {
    this.footer = document.querySelector(".floating-footer")
    this.content = document.getElementById("content")

    this.positionFooter()
    this.resizeObserver = new ResizeObserver(() => this.positionFooter())
    this.resizeObserver.observe(this.content)

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (this.footer) {
            if (entry.isIntersecting) {
              this.footer.classList.add("floating-footer--hidden")
            } else {
              this.footer.classList.remove("floating-footer--hidden")
            }
          }
        })
      },
      {
        root: this.content,
        threshold: 0.3,
      }
    )

    this.observer.observe(this.inlineCtaTarget)
  }

  positionFooter() {
    if (!this.footer || !this.content) return

    const rect = this.content.getBoundingClientRect()
    this.footer.style.left = `${rect.left}px`
    this.footer.style.right = `${window.innerWidth - rect.right}px`
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    if (this.resizeObserver) this.resizeObserver.disconnect()
  }
}
